// extracted by css-extract-rspack-plugin
export default {"moduleName":"moduleName-Osn9zz","moduleVersion":"moduleVersion-NfByN_","moduleContent":"moduleContent-EdXckv","sixDots":"sixDots-EpBiZL"};